import React from "react";
import "../index.css";

function Hero() {
  return (
    <section className="hero spikes spikes-yellow">
      <div className="hero-content">
        <h1>At <span style={{ color: "rgb(49,131,0)" }}>alltruebites</span> we believe nourishment is an act of care—for yourself and for others.</h1>
        <p>Inspired by the true meaning of altruism, we craft protein-packed snacks that support personal well-being while fostering a greater good. Our mission is to make it easy to choose health, kindness, and connection—every time you reach for a bite.</p>
        <a href="#vision" className="hero-btn">Learn more about our vision</a>
      </div>
    </section>
  );
}

export default Hero;
